(ns hypnos.consumer.panels.consult.pacemaker
  "The consult pacemaker step."
  (:require [hypnos.graphql.amplify]
            [hypnos.graphql.mutations :as mutations]
            [hypnos.i18n :refer [tr]]
            [hypnos.translator.consult :as t-c]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  (let [consult       (rf/subscribe [:consumer/consult])
        has-portrait? (:consult/has-portrait? @consult)]
    [:div.field.is-grouped
     [:p.control
      [:button.button.is-rounded.is-info
       {:on-click (fn [_]
                    (when has-portrait?
                      (rf/dispatch-sync [:amplify/mutation-api
                                         mutations/record-consult
                                         {:consult (t-c/consult->gql (t-c/consult->db @state))}
                                         :consumer/set-consult]))
                    (nav-fn state :pacemaker :next))}
       (tr :ui.label/next)]]
     [:p.control
      [:button.button.is-rounded.is-light
       {:on-click (fn [_] (nav-fn state :pacemaker :prev))}
       (tr :ui.label/prev)]]]))

(defn- statement
  [consult]
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.pacemaker/statement (:consult/service-type consult))]]])

(defn pacemaker-field
  [state]
  [:div.field.has-check ;; .is-horizontal
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.pacemaker/question))]]
   [:div.field-body
    [:div.field ;; .is-grouped-multiline.is-grouped
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "pacemaker"
                      :checked   (true? (get-in @state [:consult :consult/pacemaker? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/pacemaker? :value])
                                         new-value (when (-> e .-target .-checked) true)
                                         changed?  (or (get-in @state [:consult :consult/pacemaker? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/pacemaker? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/pacemaker? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/pacemaker? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/yes)]]]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "pacemaker"
                      :checked   (false? (get-in @state [:consult :consult/pacemaker? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/pacemaker? :value])
                                         new-value (when (-> e .-target .-checked) false)
                                         changed?  (or (get-in @state [:consult :consult/pacemaker? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/pacemaker? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/pacemaker? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/pacemaker? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/no)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The pacemaker step"
  [state nav-fn]
  (let [consult (rf/subscribe [:consumer/consult])]
    [:div.card-content
     ;; statement
     [statement @consult]
     ;; field info
     [pacemaker-field state]
     [:hr]
     ;; navigation
     [navigation state nav-fn]]))
